export default __webpack_public_path__ + "static/media/mobile_post.5cb3ed2e.svg";